module.exports = __webpack_public_path__ + "img/0Q3A0072_L_WoodMatted.954f79ab.jpg";